export default "__VITE_ASSET__DDnd8VAP__"